import PropTypes from 'prop-types';
import React from 'react';
import { formatDateTime, TIME_ZONE } from 'helpers/dateTimeFormatter';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const ConditionIndicatorTooltip = ({ timeStamp, indicatorType, kpiPoint, label, isUTC, detectedTrendX0 }) => {
    const { t: translate } = useTranslation();
    const uom = kpiPoint?.series?.tooltipOptions?.valueSuffix?.trim();
    // Format start and end times
    let startTime = '';
    let endTime = '';
    if (detectedTrendX0) {
        startTime = isUTC
            ? `${formatDateTime(detectedTrendX0, { timeZone: TIME_ZONE.UTC })} (${translate('ABB.Powertrain.Frontend.UTC')})`
            : formatDateTime(detectedTrendX0);
    }
    if (timeStamp) {
        endTime = isUTC
            ? `${formatDateTime(timeStamp, { timeZone: TIME_ZONE.UTC })} (${translate('ABB.Powertrain.Frontend.UTC')})`
            : formatDateTime(timeStamp);
    }
    return (
        <div className='condition-indicator-tooltip'>
            <div className='t-header'>
                {startTime && endTime
                    ? `${startTime} - ${endTime}`
                    : endTime}
            </div>
            <div className='t-item'>
                <span className='symbol'>
                    <img src={`data:image/svg+xml;utf8,${encodeURIComponent(indicatorType)}`} alt='' />
                </span>
                <span className='type'>
                    {label}
                </span>
            </div>
            {kpiPoint ? <div className='t-item'>
                <span className='symbol' style={{ backgroundColor: kpiPoint?.color, opacity: '1' }} />
                <span className='kpi-type'>{`${kpiPoint?.series?.name}: ${kpiPoint?.y} ${uom}`}</span>
            </div> : null}
        </div>
    );
};

ConditionIndicatorTooltip.propTypes = {
    name: PropTypes.string,
    y: PropTypes.number,
    indicatorType: PropTypes.any,
    dateConfig: PropTypes.any,
    timeStamp: PropTypes.any,
    kpiPoint: PropTypes.any,
    label: PropTypes.string,
    isUTC: PropTypes.bool,
    detectedTrendX0: PropTypes.any
};

export default ConditionIndicatorTooltip;
